var faqSearch,
	ModuleFAQSearch = Object.freeze({
		settings: {},
		init: function () {
			// kick things off
			faqSearch = this;
			this.bindUIActions();
			console.log("FAQ Search Module Ready...");
		},
		bindUIActions: function () {
			// bind events
			const searchInput = jQuery("#faq-search-field");
			const categorySelect = jQuery("#faq-search-category");
			const searchForm = jQuery("#faq-searchform-advanced");
			jQuery(document).ready(this.clearEmptyCategories);
			categorySelect.change(function (e) {
				e.preventDefault();
				faqSearch.setSearchTerm(searchInput.val());
				faqSearch.setSearchCategory(
					categorySelect[0].selectedOptions[0].innerText
				);
				faqSearch.filterFaqs();
			});
			searchForm.submit(function (e) {
				e.preventDefault();
				faqSearch.setSearchTerm(searchInput.val());
				faqSearch.setSearchCategory(
					categorySelect[0].selectedOptions[0].innerText
				);
				faqSearch.filterFaqs();
			});
			searchForm.find("#reset").on("click", function (e) {
				e.preventDefault();
				searchInput.val("");
				searchForm.submit();
			});
		},
		setSearchTerm: function (term) {
			this.settings.term = term;
		},
		setSearchCategory: function (category) {
			console.log(category);
			this.settings.category = category;
		},
		filterFaqs: function () {
			const faqs = jQuery(".faq-categories .accordion-item");
			const searchTerm = this.settings.term;
			faqs.each(function (index) {
				const faq = jQuery(this);
				const matchesSearchTerm =
					faq.text().search(new RegExp(searchTerm, "i")) >= 0;
				const matchesCategory =
					faq.data("faq-category") === faqSearch.settings.category ||
					faqSearch.settings.category === "All Categories";
				if (!matchesSearchTerm || !matchesCategory) {
					faq.addClass("--hidden");
				} else {
					faq.removeClass("--hidden");
				}
			});
			this.clearEmptyCategories();
		},
		clearEmptyCategories: function () {
			const parentLists = jQuery(".faq-categories");

			parentLists.each(function (index) {
				const parentList = jQuery(parentLists[index]);
				if (
					parentList.find(".accordion-item:not(.--hidden)").length ===
					0
				) {
					parentList.addClass("--hidden");
				} else {
					parentList.removeClass("--hidden");
				}

				const parentCategories = parentList.find(".faq-category");

				parentCategories.each(function (index) {
					const parent = jQuery(this);
					if (
						parent.find(".accordion-item:not(.--hidden)").length ===
						0
					) {
						parent.addClass("--hidden");
						return;
					} else {
						parent.removeClass("--hidden");
					}
				});
			});
		},
	});

module.exports = ModuleFAQSearch;
